"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSpinners = require("react-spinners");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const centerLoader = {
  display: "block",
  margin: "0 auto",
  top: "50%",
  left: "50%",
  position: "absolute !important",
  width: "0"
};
const topLoader = {
  display: "block",
  position: "fixed !important",
  left: "0",
  top: "0"
};

class PageLoader extends _react.default.Component {
  render() {
    const type = this.props.type;

    switch (type) {
      case 'bar':
        return /*#__PURE__*/_react.default.createElement(_reactSpinners.BarLoader, {
          style: topLoader,
          widthUnit: "%",
          width: 100,
          heightUnit: "px",
          height: 3,
          color: "#1AEEC2",
          loading: this.props.loading
        });

      case 'position':
        return /*#__PURE__*/_react.default.createElement(_reactSpinners.ScaleLoader, {
          sizeUnit: "px",
          height: 25,
          width: 4,
          radius: 2,
          color: "#1AEEC2",
          loading: this.props.loading
        });

      default:
        return /*#__PURE__*/_react.default.createElement(_reactSpinners.PropagateLoader, {
          style: centerLoader,
          sizeUnit: "px",
          size: 15,
          color: "#1AEEC2",
          loading: this.props.loading
        });
    }
  }

}

_defineProperty(PageLoader, "defaultProps", {
  type: 'center',
  loading: true
});

PageLoader.propTypes = {
  type: _propTypes.default.string,
  loading: _propTypes.default.bool
};
var _default = PageLoader;
exports.default = _default;